import { StoreState } from '@/core/models/store.interface';
import { Company } from '@nxtpeople/nxt-vue-library';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { CompanyService } from './company.service';

const service = new CompanyService();

export interface CompanyState {}

const CompanyStore: Module<CompanyState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async searchCompanies(context, query?: LocationQuery) {
         return service.getCompanies(query);
      },
      async putCompany(context, body: Company) {
         return service.putCompany(body.id, body);
      },
   },
};

export default CompanyStore;
